module.exports = __webpack_public_path__ + "static/img/cj10.d7d4227.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cj10.jpeg
// module id = dYGh
// module chunks = 0